/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.placementTest === "undefined") {
        jQuery.extend(sm.portal.vm, { placementTest: {} });
    }

    /**************************************/
    // SAT View Model
    // Holds the SAT Scores
    /**************************************/
    function SATViewModel(options) {
        var defaults = {
            PlacementTestType: 'SAT',
            ID: 0,
            TestDate: null,
            Reading: 0,
            Math: 0,
            Writing: 0,
            Essay: 0,
            Composite: 0,
            Mode: 'Add',
            Index: 0
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.PlacementTestType = ko.observable(settings.PlacementTestType);
        this.Index = ko.observable(settings.Index);
        this.ID = ko.observable(settings.ID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Reading = ko.validatedObservable(settings.Reading);
        this.Math = ko.validatedObservable(settings.Math);
        this.Writing = ko.validatedObservable(settings.Writing);
        this.Essay = ko.validatedObservable(settings.Essay);
        this.Composite = ko.validatedObservable(settings.Composite);

        // add/edit mode
        this.Mode = ko.observable(settings.Mode);

        /*** TEST PROPERTIES ***/
        this.Touched = ko.observable(false);
        this.Clone = function () {
            return new sm.portal.vm.placementTest.SATViewModel({
                ID: this.ID(),
                TestDate: this.TestDate(),
                Math: this.Math(),
                Writing: this.Writing(),
                Reading: this.Reading(),
                Essay: this.Essay(),
                Composite: this.Composite(),
                Mode: this.Mode(),
                Index: this.Index()
            });
        };
        this.Copy = function (data) {
            return new sm.portal.vm.placementTest.SATViewModel({
                ID: data.ID(),
                TestDate: data.TestDate(),
                Math: data.Math(),
                Writing: data.Writing(),
                Reading: data.Reading(),
                Essay: data.Essay(),
                Composite: data.Composite(),
                Index: data.Index()
            });
        }
        this.Clear = function () {
            this.ID('');
            this.TestDate('');
            this.Math('');
            this.Writing('');
            this.Reading('');
            this.Essay('');
            this.Composite('');
            this.Index(0);
            this.Mode('Add');
        }        
        /*** TEST PROPERTIES ***/

        /***  COMPUTED PROPERTIES ***/
        this.ScoreSummary = ko.computed(function () {
            return sm.portal.utility.getResourceValue('Math') + 'Math: ' + this.Math() +
                    ', ' + sm.portal.utility.getResourceValue('Essay') + ': ' + this.Essay() +
                    ', ' + sm.portal.utility.getResourceValue('Reading') + ': ' + this.Reading() +
                    ', ' + sm.portal.utility.getResourceValue('Writing') + ': ' + this.Writing() +
                    ', ' + sm.portal.utility.getResourceValue('Composite') + ': ' + this.Composite();
        }, this);
        this.AnythingPopulated = ko.computed(function () {

            if (!sm.portal.utility.isNullOrEmpty(self.TestDate())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Reading())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Math())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Writing())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Essay())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Composite())) return true;

            return false;

        }, this);
        /***  COMPUTED PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            return new smapi.admissions.SATModel({
                ID: self.ID(),
                TestDate: self.TestDate(),
                Reading: self.Reading(),
                Math: self.Math(),
                Writing: self.Writing(),
                Essay: self.Essay(),
                Composite: self.Composite()
            });
        };
        /*** SECTION PROPERTIES ***/

        /*** VALIDATION METHODS ***/
        this.TestDate.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Reading.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 1600,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '1600')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Math.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 1600,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '1600')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Writing.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 1600,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '1600')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Essay.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 1600,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '1600')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Composite.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 1600,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '1600')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid() && (this.AnythingPopulated() || this.Touched());
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    }

    jQuery.extend(true, sm.portal.vm.placementTest, {
        SATViewModel: SATViewModel,
    });

})(jQuery);